import ScrollTrigger from 'gsap/ScrollTrigger';
import SCORM from './SCORM';

interface ParallaxElement extends HTMLElement {
  _parallaxSt?: ScrollTrigger;
  _parallax?: number;
}

export default function createParallax(child: HTMLElement, parallax: number) {
  const el = child.parentElement as ParallaxElement;
  if (el._parallax === parallax) return;
  el._parallax = parallax;
  el._parallaxSt?.kill();

  const scroller = el.closest('.scroller') as HTMLElement;

  if (parallax === 100) return;

  el._parallaxSt = ScrollTrigger.create({
    trigger: el,
    scroller,
    start: () => `center-=${scroller.offsetHeight / 2}px bottom`,
    end: `center+=${scroller.offsetHeight / 2}px top`,
    // markers: true,
    scrub: 0.5,
    onUpdate: ({ progress }) => {
      const y = SCORM.get('reducedMotion')
        ? 0
        : ((1 - progress * 2) * window.innerHeight * (parallax - 100)) / 100;

      // console.log({ parallax, y });

      gsap.to(child, { duration: 0.5, overwrite: true, y });
    },
    onRefresh: ({ progress }) => {
      // console.log({ item: el, progress });
    }
  });
}
